/* eslint-disable prefer-object-spread */
/* eslint-disable no-shadow */
import { webviewPostMessage, jsonParser } from '@/lib/utils';

const state = {
    sdk2WebTicket: null, // 登录态传递票据
    appInfo: {
        appId: '', // 游戏 appId
        channel: '', // sdk 端渠道号
    },
    userInfo: {}, // web 登录信息
    initialRevoke: {}, // 本次注销流程的初始化信息
    captchaData: {}, // 验证码流程的信息 [loginType | userId | commitTime | flowId | action]
};

const module = {
    namespaced: true,
    state,
    mutations: {
        clearSdk2WebTicket(state) {
            state.sdk2WebTicket = null;
        },
        setSdk2WebTicket(state, platform) {
            webviewPostMessage(platform, {
                func: 'GHomeUnregisterGetWebTicket',
                callbackObj: {
                    // prettier-ignore
                    GHomeUnregisterGetWebTicketCallback(res) {
                        const { resultCode, ticket } = jsonParser(res) || {};
                        state.sdk2WebTicket = resultCode === 0
                            ? ticket
                            : `errorId_${Date.now()}`;
                    },
                },
            });
        },
        setAppInfo(state, payload) {
            state.appInfo = Object.assign({}, state.appInfo, payload);
        },
        setUserInfo(state, payload) {
            state.userInfo = payload;
        },
        setInitialRevoke(state, payload) {
            state.initialRevoke = payload;
        },
        setCaptchaData(state, payload) {
            state.captchaData = Object.assign({}, state.captchaData, payload);
        },
    },
};

export default module;
